import React from 'react';
import './GateModal.css';

interface AuthGateModalProps {
  msgCount: number;
  onAuth: () => void;
  onDismiss: () => void;
}

const AuthGateModal: React.FC<AuthGateModalProps> = ({ msgCount, onAuth, onDismiss }) => {
  return (
    <div className="gate-modal-backdrop" onClick={onDismiss}>
      <div className="gate-modal" onClick={e => e.stopPropagation()}>
        <div className="gate-modal-icon gate-modal-icon--auth">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
            <circle cx="12" cy="9" r="2.5"/>
          </svg>
        </div>
        <h3 className="gate-modal-title">You're on a roll!</h3>
        <p className="gate-modal-body">
          Sign up to keep planning with AI, save your plans, and browse plans from the community. Still free.
        </p>
        <div className="gate-modal-buttons">
          <button className="gate-modal-btn gate-modal-btn--primary" onClick={onAuth}>
            Continue with Google
          </button>
          <button className="gate-modal-btn gate-modal-btn--secondary" onClick={onAuth}>
            Continue with Apple
          </button>
          <button className="gate-modal-btn gate-modal-btn--secondary" onClick={onAuth}>
            Continue with Email
          </button>
        </div>
        <p className="gate-modal-counter">You've used {msgCount} of 3 free messages</p>
      </div>
    </div>
  );
};

export default AuthGateModal;
